import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { BoxTrUI } from './ui';

export class BoxTr extends PureComponent {
    static displayName = 'BoxTrContainer';

    render() {
        const { ...rest } = this.props;

        // PUT OTHER PROPS AFTER {...rest}
        return <BoxTrUI {...rest} />;
    }
}

export const BoxTrContainer = compose()(BoxTr);
